import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/images/logos/my-logo192.png"
                alt="StrikeAPrice"
                className="h-8 w-8"
              />
              <span className="text-xl font-bold">StrikeAPrice</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              AI-powered price monitoring and dynamic pricing software for
              modern businesses. Monitor, analyze, and optimize your pricing
              strategy with real-time market data.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-gray-400">
                <Mail className="h-4 w-4" />
                <span>support@strikeaprice.com</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/dynamic-pricing"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Dynamic Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/google-shopping"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Google Shopping
                </Link>
              </li>
              <li>
                <Link
                  to="/marketplace-monitoring"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Marketplace Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/competitor-monitoring"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Competitor Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/map-alerts"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  MAP Alerts
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/trial"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Start Trial
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 StrikeAPrice. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
